var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Header'),_c('v-breadcrumbs',{staticClass:"breadcrumbs",attrs:{"divider":"/","items":_vm.breadcrumbs}}),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"center"},[_c('h3',{staticClass:"eventLarge"},[_vm._v("Thank You!")]),_c('p',{staticClass:"eventSub"},[_vm._v(" You have been added to the 2025 Bison Roundup Waitlist ")])])
}]

export { render, staticRenderFns }